// extracted by mini-css-extract-plugin
module.exports = {"formRecuperar":"style_formRecuperar__2HWa5","alertSuccess":"style_alertSuccess__3WpbD"};